import axios from "axios";
import Swal from "sweetalert2";

export const handleRazorpayPayment = async ({
  amount,
  user,
  onSuccess,
  onFail,
}) => {
  try {
    if (!user?._id) {
      Swal.fire("Error", "Please login first", "error");
      return;
    }

    // CREATE ORDER
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/razorpay/create-order`,
      {
        amount: amount * 100, // converting to paisa here (ONLY once)
      }
    );

    if (!data.success) {
      Swal.fire("Error", "Unable to create payment order", "error");
      return;
    }

    // RAZORPAY OPTIONS
    const options = {
      key: data.key,
      amount: data.order.amount,
      currency: "INR",
      name: "PANDRA STORE",
      description: "Order Payment",
      order_id: data.order.id,

      handler: async function (response) {
        try {
          const verifyRes = await axios.post(
            `${process.env.REACT_APP_API_URL}/razorpay/verify`,
            response
          );

          if (verifyRes.data.success) {
            onSuccess();
          } else {
            Swal.fire("Error", "Payment verification failed", "error");
            onFail();
          }
        } catch (e) {
          Swal.fire("Error", "Verification error", "error");
          onFail();
        }
      },

      theme: { color: "#ff6b00" },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();

    rzp1.on("payment.failed", function () {
      Swal.fire("Payment Failed", "Try again", "error");
      onFail();
    });
  } catch (err) {
    Swal.fire("Error", "Something went wrong in payment", "error");
  }
};

